import { Button, Checkbox, Form, Input, Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import classes from './style/FreeUsersModal.module.css';
import { modalProps } from '../../Departments/Departments';
import { UsersProps } from '../../../types/Departments';
import { ApiCenter } from '../../api/ApiCenter';

const FreeUsersModal = ({
  modalClose,
  changeDepartment,
  modalProps,
}: {
  modalClose: () => void;
  changeDepartment: (
    id: number | null,
    title: string,
    category_id: number,
    userId?: number,
    userChoises?: number[],
    users?: UsersProps[]
  ) => {};
  modalProps: modalProps;
}) => {
  const { id, title, category_id } = modalProps;
  const [users, setUsers] = useState<UsersProps[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [form] = Form.useForm();
  const prevValueRef = useRef<string>();
  const Apistart = new ApiCenter();
  const timerRef = useRef<NodeJS.Timeout | undefined>();
  const [selectedPeople, setSelectedPeople] = useState<number[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<UsersProps[]>([]);
  const handleCheckboxChange = (checkedValues: CheckboxValueType[]) => {
    setSelectedPeople(checkedValues as number[]);
    const peoples = users.filter((user) => checkedValues.includes(user.id));
    setSelectedUsers(peoples);
  };
  const constructLink = (nameSearch = '') => {
    const baseUrl = 'departments/freeUsers';
    let link = baseUrl;
    switch (nameSearch) {
      case '':
        break;
      default:
        link += `?name=${nameSearch}`;
        break;
    }
    return link;
  };
  const fetchData = async (nameSearch = '') => {
    try {
      const response = await Apistart.GET_API(constructLink(nameSearch), 'GET');
      if (response.success) {
        setUsers(response.data);
      } else {
        // eslint-disable-next-line no-console
        console.error();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value !== prevValueRef.current) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      prevValueRef.current = event.currentTarget.value;
      if (prevValueRef.current) {
        timerRef.current = setTimeout(() => {
          fetchData(prevValueRef.current ? prevValueRef.current : event?.currentTarget?.value);
        }, 800);
      } else {
        fetchData('');
      }
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    modalClose();
  };
  return (
    <Modal open={isModalOpen} onCancel={handleCancel} footer={null} className={classes.modal}>
      <h1>Добавить сотрудника</h1>
      <Form form={form} autoComplete="off" layout="vertical">
        <Form.Item style={{ width: '100%' }} label="Поиск по названию">
          <Input
            placeholder="Поиск..."
            prefixCls=""
            suffix={<SearchOutlined />}
            onChange={handleSearch}
          />
        </Form.Item>
        <h2>Сотрудники без отдела:</h2>
        <Checkbox.Group
          onChange={handleCheckboxChange}
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
          }}
        >
          <div className={classes.usersWrapper}>
            {users.map((person) => (
              <Checkbox key={person.id} value={person.id} className={classes.userCheck}>
                {person.name}
              </Checkbox>
            ))}
          </div>
        </Checkbox.Group>
        <div className={classes.buttonGroop}>
          <Button style={{ width: '50%' }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            disabled={users.length < 1 || selectedPeople.length < 1}
            style={{ width: '50%' }}
            type="primary"
            onClick={() =>
              changeDepartment(id, title, category_id, undefined, selectedPeople, selectedUsers)
            }
          >
            Добавить
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default FreeUsersModal;
